import './common.scss';
import './App.css';
import { ToastContainer } from "react-toastify";
import Navbar from './routes/Navbar/Navbar';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Login from './routes/Login/Login';
import Dashboard from './routes/Dashboard/Dashboard';
import MyOrders from './routes/MyOrders/MyOrders';
import Profile from './routes/Profile/Profile';
import Privacy from './routes/Privacy';
import Terms from './routes/Terms';
import ResetPassword from "./routes/ResetPassword/ResetPassword";
import RFQDetails from './routes/RFQDetails/RFQDetails';
import OrderDetails from './routes/OrderDetails/OrderDetails';
import Maintanence from './component/Maintanence';
import { useEffect } from 'react';
import qs from 'query-string';
import PrivateRoute from './routes/PrivateRoute';
import { firebaseSignOnLoginSuccess } from './utils/firebase';
import jwt_decode from 'jwt-decode';
import { verifySso } from './utils/actions/loginActions';

function App() {
  let loggedIn = localStorage.getItem('isLoggedIn');
  let token = localStorage.getItem('Token');
  const location = useLocation();

  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("Token");
    localStorage.removeItem("_id");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("email");
    localStorage.removeItem("pathAfterLogin");
    navigate('/');
  };


  useEffect(() => {
    // Get the full URL of the current page
    const url = new URL(window.location.href);

    // Use URLSearchParams to parse the query string
    const queryParams = new URLSearchParams(url.search);

    // Extract the token from the query parameter 'sso'
    const tokenParam = queryParams.get('sso');
    if (tokenParam) {
      const parsedToken = JSON.parse(tokenParam);
      console.log("Parsed data ::",parsedToken);
      (async () => {
        const response = await verifySso(parsedToken);
        console.log("Response ::", response);
        if (!response?.status) {
          navigate('/login');
          return;
        }
        //user if valid login
        localStorage.setItem("Token", response?.data?.token);
        localStorage.setItem("firstName", response?.data?.firstName);
        localStorage.setItem("lastName", response?.data?.lastName);
        localStorage.setItem("email", response?.data?.email);
        localStorage.setItem("_id", response?.data?._id);
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem(
          "tokenValidTill",
          new Date(Date.now() + 86400000 * 30).valueOf()
        );
        sessionStorage.setItem("isLoggedIn", true);
        navigate('/my-orders');
      })()
    }
  }, []);
  useEffect(() => {
    console.log(window.location.host, 'sc.dainsta.com', (window.location.host === 'sc.dainsta.com') ? "Gtm loaded" : "GTM not loaded")
    if (window.location.host === 'sc.dainsta.com') {
      loadGTM();
    }
    token = localStorage.getItem('Token');

    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (!token) {
      if (!(location.pathname.includes('verifyEmail'))) {
        handleLogout();
        return;
      }
    } else {
      let decode = jwt_decode(token);
      if ((decode.exp * 1000) < Date.now()) {
        handleLogout();
      }
      if ((decode.exp * 1000) - Date.now() < 1800) {
        handleLogout();
      }
    }

    if (isLoggedIn != 'true' && !(location.pathname.includes('verifyEmail'))) {
      handleLogout();
    }
    firebaseSignOnLoginSuccess();
    const { search, } = window.location;
    const param = qs.parse(search);
    if (param.redirected_url && token) {
      window.href = param.redirected_url + search;
    };
  }, [])


  const loadGTM = () => {
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://insights.dainsta.com/gtm.js?st='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','M9FSQD8');`;
    document.head.appendChild(gtmScript);
  };


  return (
    <div className="App ">
      <ToastContainer />
      <Routes>
        {process.env.REACT_APP_IN_MAINTANANCE == 'true' ?
          <>
            <Route path='/*' element={<Maintanence />} />
          </>
          :
          <>
            <Route path='/' element={loggedIn && token ? <Navigate to='/dashboard' /> : <Login />} />
            <Route path='/login' element={loggedIn && token ? <Navigate to='/dashboard' /> : <Login />} />
            <Route path="/:id/verifyEmail/" element={<ResetPassword />}></Route>
            <Route path='/' element={<Navbar />}>

              <Route path='/dashboard' element={<PrivateRoute />}>
                <Route path='/dashboard' element={<Dashboard />} />
              </Route>
              <Route path='/my-orders' element={<PrivateRoute />}>
                <Route path='/my-orders' element={<MyOrders />} />
              </Route>

              <Route path='/profile' element={<PrivateRoute />}>
                <Route path='/profile' element={<Profile />} />
              </Route>

              <Route path='/rfq-details/:id' element={<PrivateRoute />}>
                <Route path="/rfq-details/:id" element={<RFQDetails />} />
              </Route>

              <Route path='/order-details/:id' element={<PrivateRoute />}>
                <Route path="/order-details/:id" element={<OrderDetails />} />
              </Route>
            </Route>
            <Route path="/privacy-policy" element={<Privacy />}></Route>
            <Route path="/terms-of-service" element={<Terms />}></Route>
          </>
        }

      </Routes>
    </div>
  );
}

export default App;
